import getColor from "@insite/mobius/utilities/getColor";
import widgetModule, { welcomeStyles } from "@stoneage/App/Widgets/Welcome/Welcome";
import { css } from "styled-components";

welcomeStyles.linkContainer = {
    ...welcomeStyles.linkContainer,
    css: css`
        ${welcomeStyles.linkContainer?.css};
        &,
        span,
        svg {
            color: ${getColor("primary")} !important;
        }

        &:hover,
        &:focus {
            &,
            span,
            svg {
                color: ${getColor("secondary")} !important;
            }
        }
    `,
};

export * from "@stoneage/App/Widgets/Welcome/Welcome";
export default widgetModule;
